import { combineReducers } from 'redux';
import { handleActions, combineActions } from 'redux-actions';
import {
  SEARCH_VALUE_BY_TYPE_REQUEST,
  SEARCH_VALUE_BY_TYPE_SUCCESS,
  SEARCH_VALUE_BY_TYPE_FAILURE,
} from '../../../search/containers/constants';

export const vendors = handleActions(
  {
    [SEARCH_VALUE_BY_TYPE_REQUEST]: () => [],
    [SEARCH_VALUE_BY_TYPE_SUCCESS]: (state, { payload }) =>
      payload.type === 'vendor' ? payload.items : [],
  },
  [],
);

export const isVendorsLoading = handleActions(
  {
    [SEARCH_VALUE_BY_TYPE_REQUEST]: () => true,
    [combineActions(
      SEARCH_VALUE_BY_TYPE_SUCCESS,
      SEARCH_VALUE_BY_TYPE_FAILURE,
    )]: () =>
        false,
  },
  false,
);

export default combineReducers({
  vendors,
  isVendorsLoading,
});
